<!--<div [formGroup]="form">
  <div class="row">
    <div class="col-sm-4">
      <label for="rng" class="radiobox-inline">
        <input id="rng" type="radio" value="rng" name="type" formControlName="type" />
        Range
      </label>
    </div>
    <div class="col-sm-4">
      <label for="lte" class="radiobox-inline">
        <input id="lte" type="radio" value="lte" name="type" formControlName="type" />
        Less Than
      </label>
    </div>
    <div class="col-sm-4">
      <label for="gte" class="radiobox-inline">
        <input id="gte" type="radio" value="gte" name="type" formControlName="type" />
        Greater Than
      </label>
    </div>
  </div>
  <div *ngIf="utilityobj.type == 'rng'">
    <div class="row">
      <div class="col-sm-6">
        <div class="amount-from">
          <label for="amtfrom">Amount from</label>
          <input type="number" id="amtfrom" formControlName="fromamount" >
          <span class="help-block"
                *ngIf="!form.get('fromamount').valid && form.get('fromamount').touched">Required</span>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="amount-to">
          <label for="amtto">Amount to</label>
          <input type="number" id="amtto" formControlName="toamount">
          <span class="help-block"
                *ngIf="!form.get('toamount').valid && form.get('toamount').touched">
            <div *ngIf="form.get('toamount').errors && form.get('toamount').errors.required">
              Required
            </div>
          </span>
          <span class="help-block"
                *ngIf="form.get('toamount').errors && form.get('toamount').errors.invalidRange">Amount To must be greater than Amount From</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="utilityobj.type=='lte' || utilityobj.type=='gte'">
      <div class="row">
        <div class="col-sm-6">
          <div class="amount-from">
            <label for="amtfrom">Amount</label>
            <input type="text" id="amtfrom" formControlName="fromamount" [ngModel]="utilityobj.fromAmount">
            <span class="help-block"
                  *ngIf="!form.get('fromamount').valid && form.get('fromamount').touched">Required</span>
          </div>
        </div>
        <div class="col-sm-6">

        </div>
      </div>
  </div>

  </div>-->

<div [formGroup]="form">

  <div class="form-check-inline">
    <input id="rng" type="radio" class="form-check-input" value="rng" name="type" formControlName="type" />
    <label for="rng" class="form-check-label">Range </label>
  </div>
  <div class="form-check-inline">
    <input id="lte" type="radio" class="form-check-input" value="lte" name="type" formControlName="type" />
    <label for="lte" class="form-check-label">Less Than </label>
  </div>
  <div class="form-check-inline">
    <input id="gte" type="radio" class="form-check-input" value="gte" name="type" formControlName="type" />
    <label for="gte" class="form-check-label">Greater Than </label>
  </div>


  <div *ngIf="utilityobj.type == 'rng'">
    <div class="amount-from">
      <label for="amtfrom">Amount from</label>
      <input type="number" id="amtfrom" formControlName="fromamount">
      <div class="help-block">
        <span *ngIf="!form.get('fromamount').valid && form.get('fromamount').touched">Required</span>
      </div>
    </div>
    <div class="space"></div>
    <div class="amount-to">
      <label for="amtto">Amount to</label>
      <input type="number" id="amtto" formControlName="toamount">
      <div class="help-block">
        <span *ngIf="!form.get('toamount').valid && form.get('toamount').touched">
          <span *ngIf="form.get('toamount').errors && form.get('toamount').errors.required"> Required </span>
        </span>
        <span *ngIf="form.get('toamount').errors && form.get('toamount').errors.invalidRange">Amount To must be greater than Amount From</span>
      </div>
    </div>
  </div>


  <div *ngIf="utilityobj.type=='lte' || utilityobj.type=='gte'">
    <div class="amount-from">
      <label for="amtfrom">Amount</label>
      <input type="text" id="amtfrom" formControlName="fromamount" [ngModel]="utilityobj.fromAmount">
      <div class="help-block">
        <span *ngIf="!form.get('fromamount').valid && form.get('fromamount').touched">Required</span>
      </div>
    </div>
  </div>

</div>
